import Vue from 'vue';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faLink, faSpinner } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import WebFont from 'webfontloader';
import App from './App.vue';
import router from './router';
import store from './store';
import './registerServiceWorker';

// Font Awesome configuration
library.add(faLink);
library.add(faSpinner);
Vue.component('font-awesome-icon', FontAwesomeIcon);

Vue.config.productionTip = false;

WebFont.load({
  google: {
    families: ['Source Sans Pro'],
  },
});

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
